import React, { useState, useEffect } from 'react';
import { Layout, Menu, List, Card, Button, Input, Modal, Form, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Link } from 'react-router-dom';
import ForumAuth from './ForumAuth';
import AddTopic from './AddTopic';

const { Content, Sider } = Layout;
const { TextArea } = Input;

const Forum = () => {
    const [categories, setCategories] = useState([]);
    const [topics, setTopics] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [auth, setAuth] = useState(false);

    // Kategoriyalarni yuklash
    useEffect(() => {
        axios.get('/bookcats').then(res => {
            setCategories(res.data);
            if (res.data.length > 0) {
                setSelectedCategory(res.data[0].id);
            }
        }).catch(err => {
            console.error('Kategoriyalarni yuklashda xatolik:', err);
            message.error('Kategoriyalarni yuklashda xatolik yuz berdi');
        });

        let token = localStorage.getItem('token');
        if (token) {
            setAuth(true);
        }
    }, []);
    const fetchTopics = async (categoryId) => {
        try {
            const response = await axios.get(`/forum/topics/${categoryId}`);
            setTopics(response.data);
        } catch (error) {
            console.error('Mavzularni yuklashda xatolik:', error);
            message.error('Mavzularni yuklashda xatolik yuz berdi');
        }
    };
    // Tanlangan kategoriya bo'yicha mavzularni yuklash
    useEffect(() => {

        if (selectedCategory) {
            fetchTopics(selectedCategory);
        }
    }, [selectedCategory]);

    if (auth) {
        return <ForumAuth setAuth={setAuth} />
    }





    return (
        <Layout style={{ minHeight: '100vh', background: '#fff' }}>
            <Sider width={250} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
                <div style={{ padding: '16px' }}>
                    <h4>Kategoriyalar</h4>
                </div>
                <Menu
                    mode="inline"
                    selectedKeys={[selectedCategory?.toString()]}
                    onSelect={({ key }) => setSelectedCategory(parseInt(key))}
                >
                    {categories.map(category => (
                        <Menu.Item key={category.id}>
                            {category.name}
                        </Menu.Item>
                    ))}
                </Menu>
            </Sider>
            <Content style={{ padding: '24px' }}>
                <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h5>{categories.find(c => c.id === selectedCategory)?.name || 'Forum'}</h5>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setIsModalVisible(true)}
                    >
                        Yangi mavzu
                    </Button>
                </div>
                <List
                    grid={{ gutter: 16, column: 1 }}
                    dataSource={topics}
                    renderItem={topic => (
                        <List.Item>
                            <Card>
                                <Link to={`/forum/topic/${topic.id}`}>
                                    <Card.Meta
                                        title={topic.title}
                                        description={
                                            <div>
                                                <p>{topic.description}</p>
                                                <div style={{ marginTop: '8px', color: '#8c8c8c' }}>
                                                    <span>Muallif: {topic?.fullname || 'Noma\'lum'}</span>
                                                    <span style={{ marginLeft: '16px' }}>
                                                        {new Date(topic.created_at).toLocaleDateString()}
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </Link>
                            </Card>
                        </List.Item>
                    )}
                />

                <AddTopic fetchTopics={fetchTopics} isModalVisible={isModalVisible} selectedCategory={selectedCategory} setIsModalVisible={setIsModalVisible} />
            </Content>
        </Layout>
    );
};

export default Forum;
